import React, {Component} from 'react';
import { Box } from 'reactjs-admin-lte';
import BookPartItemTable from './BookPartItemTable';

class PartItemTable extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false}

  }

  componentDidMount(){

  }

  render() {
    let {loading} = this.state
    return(
      <div>
        <Box loading={loading} border={false}>
          <Box.Header>
            <Box.Title></Box.Title>
            <Box.Tools>
              
            </Box.Tools>
          </Box.Header>
          <Box.Body>
            <div className='table table-responsive'>
              <BookPartItemTable
                pageNo={1} 
                bookId={'hino'}
                selectColumn={['0','1','2','3']}
              >
              </BookPartItemTable>
            </div>  
          </Box.Body>
        </Box>
      </div>    
    )
  }
}  

export default PartItemTable;


// WEBPACK FOOTER //
// ./src/view/book/PartItemTable.js